module.exports = __webpack_public_path__ + "media/images/icon/icon_g1-f7d9cdafaa67cdae1b49943bd1964e6a.png";